<template>
  <div id="left-menu">
    <v-navigation-drawer
      class="v-navigation-drawer"
      :width="220"
      v-model="drawer"
      :clipped="$vuetify.breakpoint.lgAndUp"
      app
    >
      <v-list dense>
        <div v-for="item in MenuItems" :key="item.text">
          <v-list-item
            v-if="item.type === 'single'"
            link
            :to="item.link"
            :class="
              item.activePath === $route.meta.activePath
                ? 'v-list-item--active'
                : ''
            "
          >
            <v-list-item-action>
              <v-icon size="20">{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-title>{{ item.text }}</v-list-item-title>
          </v-list-item>

          <div v-else-if="item.type === 'header'">
            <v-list-group :value="isHeaderActive(item)" no-action>
              <template v-slot:activator>
                <v-list-item class="pa-0 ma-0">
                  <v-list-item-action>
                    <v-icon size="20">{{ item.icon }}</v-icon>
                  </v-list-item-action>
                  <v-list-item-title>{{ item.text }}</v-list-item-title>
                </v-list-item>
              </template>

              <v-list-item
                v-for="child in item.children"
                :key="child.text"
                link
                :to="child.link"
                :class="
                  child.activePath === $route.meta.activePath
                    ? 'v-list-item--active'
                    : ''
                "
                class="ml-4"
              >
                <v-list-item-action>
                  <v-icon size="20">{{ child.icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-title class="text-caption">{{
                  child.text
                }}</v-list-item-title>
              </v-list-item>
            </v-list-group>
          </div>
        </div>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
export default {
  data: () => ({
    items: [
      { icon: "mdi-home", text: "Home", link: "/", activePath: "/" },
      {
        icon: "mdi-lightbulb-on",
        text: "Jobs",
        link: "/products",
        activePath: "products",
      },
      {
        icon: "mdi-lightbulb-on",
        text: "Jobs",
        link: "/supplier",
        activePath: "suppliers",
      },
      {
        icon: "mdi-account-multiple-plus",
        text: "Clients",
        link: "/customers",
        activePath: "customers",
      },
      {
        icon: "mdi-account-multiple",
        text: "System Users",
        link: "/employers",
        activePath: "employers",
      },
      {
        icon: "mdi-chart-line",
        text: "Reports",
        link: "/reports",
        activePath: "reports",
      },
      {
        icon: "mdi-invoice",
        text: "Invoices",
        link: "/invoices",
        activePath: "invoices",
      },
      {
        icon: "mdi-shield-account",
        text: "Roles and Permissions",
        link: "/roles",
        activePath: "roles",
      },
    ],
    logo: require("@/assets/logo.png"),
  }),

  props: {
    MenuItems: {
      type: Array,
      required: true,
    },
  },

  computed: {
    drawer: {
      get() {
        return this.$store.state.auth.drawer;
      },
      set(value) {
        this.$store.commit("auth/setDrawer", value);
      },
    },
  },

  watch: {
    drawer(value) {
      this.toggleNav(value);
    },
  },

  methods: {
    toggleNav: function(value) {
      this.$store.dispatch("auth/changeDrawer", value);
    },

    isHeaderActive(header) {
      if (!header.children) return false;
      return header.children.some(
        (child) => child.activePath === this.$route.meta.activePath
      );
    },
  },
};
</script>

<style scoped>
.v-application--is-ltr
  .v-list-group--no-action
  > .v-list-group__items
  > .v-list-item {
  padding-left: 14px !important;
}

/* Vue 2 / Vuetify 2 deep selector */
::v-deep .v-navigation-drawer__content {
  scrollbar-width: none !important;
}

::v-deep .v-navigation-drawer__content::-webkit-scrollbar {
  display: none !important;
}

.v-application--is-ltr .v-list-item__action:first-child,
.v-application--is-ltr .v-list-item__icon:first-child {
  margin-right: 10px !important;
}
</style>
